module.exports = "./img/ae80994bae13bc431135d5a5c70e5fec.jpg";